import { Route, Navigate } from 'react-router-dom'
import { Connections } from '@/features/mcp/pages/Connections'
import { SettingsLayout } from './SettingsLayout'
import { AccountSettings } from './pages/AccountSettings'
import { BalanceSettings } from './pages/BalanceSettings'

/**
 * Поддерево маршрутов раздела настроек ОДНИМ объявлением: его читают и
 * `AppLayout`, и тест маршрутов.
 *
 * Собранная в тесте копия дерева охраняла бы саму себя: удаление
 * index-редиректа из приложения оставило бы её зелёной. Тот же приём и по той
 * же причине, что у `providerMounted.test.tsx`, который спрашивает настоящий
 * `App()`, а не собранное руками дерево.
 *
 * Адрес `settings/connections` сохранён с тех пор, когда он был единственным
 * маршрутом настроек, — ссылка из меню профиля продолжает работать.
 */
export const settingsRoutes = (
  <Route path="settings" element={<SettingsLayout />}>
    {/* Голый /settings иначе рисует заголовок с навигацией и пустую правую
        колонку — тупик для закладки и для набранного руками адреса. */}
    <Route index element={<Navigate to="account" replace />} />
    <Route path="account" element={<AccountSettings />} />
    <Route path="balance" element={<BalanceSettings />} />
    <Route path="connections" element={<Connections />} />
  </Route>
)
